module.exports = __webpack_public_path__ + "static/media/background_circle_blue_modal.fd2f7626.svg";